import { ReactNode, useCallback } from 'react';
import { confirmable, ConfirmDialogProps as ReactConfirmDialogProps } from 'react-confirm';
import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

import { ContentModal } from '@/dmdrive/ui-kit/components';

export interface ConfirmDialogOptions {
  confirmation: ReactNode;
  title?: string;
  declineProps?: {
    label?: string;
    variant?: ButtonProps['variant'];
    color?: ButtonProps['color'];
  };
  confirmProps?: {
    label?: string;
    variant?: ButtonProps['variant'];
    color?: ButtonProps['color'];
  };
}

function ConfirmDialog(props: ReactConfirmDialogProps<ConfirmDialogOptions, boolean>) {
  const { title = 'Are you sure?', confirmation, show: isOpen, proceed, declineProps, confirmProps } = props;

  const { label: declineLabel = 'Cancel', variant: declineVariant, color: declineColor } = declineProps ?? {};
  const {
    label: confirmLabel = 'Confirm',
    variant: confirmVariant = 'contained',
    color: confirmColor = 'error',
  } = confirmProps ?? {};

  const onConfirm = useCallback(() => proceed(true), [proceed]);
  const onDecline = useCallback(() => proceed(false), [proceed]);

  return (
    <ContentModal maxWidth="xs" onClose={onDecline} open={isOpen}>
      <ContentModal.Header onClose={onDecline}>{title}</ContentModal.Header>

      <ContentModal.Body>{confirmation}</ContentModal.Body>

      <ContentModal.Footer>
        <Button type="button" variant={declineVariant} color={declineColor} onClick={onDecline}>
          {declineLabel}
        </Button>

        <Button type="button" variant={confirmVariant} color={confirmColor} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ContentModal.Footer>
    </ContentModal>
  );
}

export default confirmable(ConfirmDialog);
